"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Icon from "../Icon/index.js";
import { useFormControl } from "../FormControl/index.js";
import Actionable from "../Actionable/index.js";
import Text from "../Text/index.js";
import IconArrow from "../../icons/ChevronVertical.js";
import { classNames, responsiveClassNames, responsivePropDependency } from "../../utilities/props.js";
import useElementId from "../../hooks/useElementId.js";
import s from "./Select.module.css";
const Select = (props) => {
    const { onChange, onClick, onFocus, onBlur, name, value, defaultValue, placeholder, options, children, icon, startSlot, size = "medium", variant = "outline", className, attributes, } = props;
    const [empty, setEmpty] = React.useState(value === undefined ? !defaultValue : !value);
    const formControl = useFormControl();
    const id = useElementId(props.id);
    const inputId = formControl?.attributes?.id || props.inputAttributes?.id || id;
    const disabled = formControl?.disabled || props.disabled;
    const hasError = formControl?.hasError || props.hasError;
    const inputAttributes = { ...props.inputAttributes, ...formControl?.attributes };
    const rootClassName = classNames(s.root, className, size && responsiveClassNames(s, "--size", size), hasError && s["--status-error"], disabled && s["--disabled"], empty && options && s["--placeholder"], variant && s[`--variant-${variant}`]);
    const handleChange = (event) => {
        const nextValue = event.target.value;
        // Uncontrolled placeholder
        if (value === undefined)
            setEmpty(!nextValue);
        if (!onChange)
            return;
        onChange({ name, value: nextValue, event });
    };
    // Controlled placeholder
    React.useEffect(() => {
        if (value === undefined)
            return;
        setEmpty(!value);
    }, [value]);
    const startContent = (startSlot || icon) && (_jsx("div", { className: s.slot, children: icon ? (_jsx(Icon, { size: responsivePropDependency(size, (size) => {
                if (size === "large")
                    return 5;
                if (size === "xlarge")
                    return 6;
                return 4;
            }), svg: icon })) : (startSlot) }));
    return (_jsxs("div", { ...attributes, className: rootClassName, children: [options ? (_jsxs(_Fragment, { children: [startContent, _jsxs("select", { ...inputAttributes, onFocus: (onFocus || inputAttributes?.onFocus), onBlur: (onBlur || inputAttributes?.onBlur), className: s.input, disabled: disabled, name: name, value: value, defaultValue: defaultValue, onChange: handleChange, id: inputId, children: [placeholder && _jsx("option", { value: "", children: placeholder }), options.map((option) => (_jsx("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value)))] })] })) : (_jsxs(_Fragment, { children: [_jsxs(Actionable, { className: s.input, disabled: disabled, disableFocusRing: true, onClick: onClick, attributes: {
                            ...inputAttributes,
                            onFocus: onFocus || inputAttributes?.onFocus,
                            onBlur: onBlur || inputAttributes?.onBlur,
                        }, children: [startContent, children || (placeholder ? _jsx(Text, { color: "neutral-faded", children: placeholder }) : null)] }), _jsx("input", { type: "hidden", value: value, name: name })] })), _jsx("div", { className: s.arrow, children: _jsx(Icon, { svg: IconArrow, color: disabled ? "disabled" : "neutral-faded", size: responsivePropDependency(size, (size) => {
                        return size === "large" || size === "xlarge" ? 5 : 4;
                    }) }) })] }));
};
Select.displayName = "Select";
export default Select;
